// Documentation autorisée pendant les examens CKAD/CKA/CKS.
//
// À l'examen réel, un seul onglet de navigateur donne accès à kubernetes.io/docs
// (+ quelques domaines annexes). On reproduit ces liens ici pour être « dans les
// mêmes conditions ». Les liens s'ouvrent dans un nouvel onglet.

export interface DocLink {
  label: string;
  url: string;
}

export interface DocGroup {
  group: string;
  links: DocLink[];
}

// Domaines autorisés à l'examen (affiché comme rappel).
export const ALLOWED_DOMAINS = ['kubernetes.io/docs', 'kubernetes.io/blog', 'helm.sh/docs'];

export const EXAM_DOCS: DocGroup[] = [
  {
    group: 'Essentiel',
    links: [
      { label: 'Documentation Kubernetes', url: 'https://kubernetes.io/docs/home/' },
      { label: 'kubectl Cheat Sheet', url: 'https://kubernetes.io/docs/reference/kubectl/cheatsheet/' },
      { label: 'Référence des commandes kubectl', url: 'https://kubernetes.io/docs/reference/generated/kubectl/kubectl-commands' },
    ],
  },
  {
    group: 'Workloads',
    links: [
      { label: 'Pods', url: 'https://kubernetes.io/docs/concepts/workloads/pods/' },
      { label: 'Deployments', url: 'https://kubernetes.io/docs/concepts/workloads/controllers/deployment/' },
      { label: 'Jobs & CronJobs', url: 'https://kubernetes.io/docs/concepts/workloads/controllers/job/' },
      { label: 'StatefulSets', url: 'https://kubernetes.io/docs/concepts/workloads/controllers/statefulset/' },
    ],
  },
  {
    group: 'Configuration & Réseau',
    links: [
      { label: 'ConfigMaps', url: 'https://kubernetes.io/docs/concepts/configuration/configmap/' },
      { label: 'Secrets', url: 'https://kubernetes.io/docs/concepts/configuration/secret/' },
      { label: 'Services', url: 'https://kubernetes.io/docs/concepts/services-networking/service/' },
      { label: 'Namespaces', url: 'https://kubernetes.io/docs/concepts/overview/working-with-objects/namespaces/' },
    ],
  },
  {
    group: 'Sécurité (CKS)',
    links: [
      { label: 'RBAC', url: 'https://kubernetes.io/docs/reference/access-authn-authz/rbac/' },
      { label: 'Security Context', url: 'https://kubernetes.io/docs/tasks/configure-pod-container/security-context/' },
      { label: 'Network Policies', url: 'https://kubernetes.io/docs/concepts/services-networking/network-policies/' },
      { label: 'Service Accounts', url: 'https://kubernetes.io/docs/tasks/configure-pod-container/configure-service-account/' },
    ],
  },
];
